import activities_en from "./data/activities_en.json";
import actors_en from "./data/actors_en.json";
import athletes_en from "./data/athletes_en.json";
import authors_en from "./data/authors_en.json";
import cartoon_en from "./data/cartoon_en.json";
import celebrities_en from "./data/celebrities_en.json";
import comedians_en from "./data/comedians_en.json";
import comics_en from "./data/comics_en.json";
import fairytales_en from "./data/fairytales_en.json";
import fantasy_en from "./data/fantasy_en.json";
import fictional_en from "./data/fictional_en.json";
import historical_en from "./data/historical_en.json";
import inventors_en from "./data/inventors_en.json";
import mascots_en from "./data/mascots_en.json";
import musicians_en from "./data/musicians_en.json";
import politicians_en from "./data/politicians_en.json";
import popculture_en from "./data/popculture_en.json";
import superheroes_en from "./data/superheroes_en.json";
import tvhosts_en from "./data/tvhosts_en.json";
import videogame_en from "./data/videogame_en.json";
import villains_en from "./data/villains_en.json";
import locale_en from "./data/locale_en.json";

import activities_fi from "./data/activities_fi.json";
import actors_fi from "./data/actors_fi.json";
import athletes_fi from "./data/athletes_fi.json";
import authors_fi from "./data/authors_fi.json";
import cartoon_fi from "./data/cartoon_fi.json";
import celebrities_fi from "./data/celebrities_fi.json";
import comedians_fi from "./data/comedians_fi.json";
import comics_fi from "./data/comics_fi.json";
import fairytales_fi from "./data/fairytales_fi.json";
import fantasy_fi from "./data/fantasy_fi.json";
import fictional_fi from "./data/fictional_fi.json";
import historical_fi from "./data/historical_fi.json";
import inventors_fi from "./data/inventors_fi.json";
import mascots_fi from "./data/mascots_fi.json";
import musicians_fi from "./data/musicians_fi.json";
import politicians_fi from "./data/politicians_fi.json";
import popculture_fi from "./data/popculture_fi.json";
import superheroes_fi from "./data/superheroes_fi.json";
import tvhosts_fi from "./data/tvhosts_fi.json";
import videogame_fi from "./data/videogame_fi.json";
import villains_fi from "./data/villains_fi.json";
import locale_fi from "./data/locale_fi.json";

export interface Locale {
  localeCode: string;
  activities: string[];
  categories: { name: string; characters: string[] }[];
  text: typeof locale_en;
}

export const locales: Record<string, Locale> = {
  en: {
    localeCode: "en",
    activities: activities_en,
    categories: [
      actors_en,
      athletes_en,
      authors_en,
      cartoon_en,
      celebrities_en,
      comedians_en,
      comics_en,
      fairytales_en,
      fantasy_en,
      fictional_en,
      historical_en,
      inventors_en,
      mascots_en,
      musicians_en,
      politicians_en,
      popculture_en,
      superheroes_en,
      tvhosts_en,
      videogame_en,
      villains_en,
    ],
    text: locale_en,
  },
  fi: {
    localeCode: "fi",
    activities: activities_fi,
    categories: [
      actors_fi,
      athletes_fi,
      authors_fi,
      cartoon_fi,
      celebrities_fi,
      comedians_fi,
      comics_fi,
      fairytales_fi,
      fantasy_fi,
      fictional_fi,
      historical_fi,
      inventors_fi,
      mascots_fi,
      musicians_fi,
      politicians_fi,
      popculture_fi,
      superheroes_fi,
      tvhosts_fi,
      videogame_fi,
      villains_fi,
    ],
    text: locale_fi,
  },
};
